"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.modeLabelFocusStyles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Constant2 = require("../../Dashboard/Constant");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  position: relative;\n  margin-bottom: 16px;\n  padding-top: 16px;\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  max-width: ", ";\n\n  label {\n    padding-right: ", ";\n  }\n\n  // TODO: remove\n  &[data-error='true'] {\n    select {\n      border-bottom: 1px solid ", ";\n    }\n  }\n\n  /* focus-within is used to target the <label> because CSS does not have a previous sibling selector */\n  &:focus-within {\n    label {\n      ", "\n      ", "\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * This component is used in both `dashboard` and `onboarding` flows.
 * Currently, the label only changes color when the input has focus in the onboarding flow.
 */
var flowLabelFocusStyles = (0, _styledTheming.default)('flow', {
  dashboard: "color: ".concat(_Constant2.Color.BLACK_SOUL, ";")
});
var modeLabelFocusStyles = (0, _styledTheming.default)('mode', (0, _defineProperty2.default)({
  caliber: "color: ".concat(_Constant.Color.CALIBER_BLUE_NEW, ";"),
  homepoint: "color: ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";"),
  figure: "color: ".concat(_Constant.Color.FOCUS_B, ";"),
  pella: "color: ".concat(_Constant.Color.FOCUS_B, ";"),
  petersendean: "color: ".concat(_Constant.Color.FOCUS_B, ";")
}, _Constant.Themes.GUARANTEED_RATE, "color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")));
exports.modeLabelFocusStyles = modeLabelFocusStyles;

var _default = _styledComponents.default.div.attrs(function (_ref) {
  var errorText = _ref.errorText;
  return {
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject(), function (props) {
  return props.alignLabelLeft && 'flex';
}, function (props) {
  return props.alignLabelLeft && 'center';
}, function (props) {
  return props.alignLabelLeft && 'space-between';
}, function (props) {
  return props.alignLabelLeft && '420px';
}, function (props) {
  return props.alignLabelLeft && '5px';
}, _Constant.Color.ERROR, modeLabelFocusStyles, flowLabelFocusStyles);

exports.default = _default;